import React from "react";
import ReactDOM from "react-dom/client";
import "../src/styles/scss/styles.scss";
import "../src/styles/scss/global.scss";

import App from "./components/App/App";

const root = document.getElementById("root");
const observer = new ResizeObserver((entries) => {
  for (const entry of entries) {
    window.parent && window.parent.postMessage(entry.contentRect, "*");
  }
})
observer.observe(root);
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
